/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Number_In_Use_LinkInputs */

const vi_einvoice_err_number_in_use_link = /** @type {(inputs: Einvoice_Err_Number_In_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem đơn`)
};

/**

* @param {Einvoice_Err_Number_In_Use_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_number_in_use_link = /** @type {((inputs?: Einvoice_Err_Number_In_Use_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Number_In_Use_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_number_in_use_link(inputs)
});